(function () {
  'use strict';

  const BlogAttribution = {
    // Check if we're on a blog article page
    isBlogPage: function () {
      return window.location.pathname.includes('/blogs/');
    },

    // Extract blog and article info from URL
    getBlogInfo: function () {
      const pathname = window.location.pathname;
      const match = pathname.match(/\/blogs\/([^/]+)(?:\/([^/]+))?/);

      if (!match) return null;

      const blogHandle = match[1];
      const articleHandle = match[2] || null;

      return {
        blogHandle: blogHandle,
        articleHandle: articleHandle,
        blogPath: '/blogs/' + blogHandle,
        articlePath: articleHandle ? '/blogs/' + blogHandle + '/' + articleHandle : null,
        fullUrl: window.location.href,
        timestamp: Date.now(),
      };
    },

    // Get blog title from page
    getBlogTitle: function () {
      // Try to get from meta tags first
      const metaTitle = document.querySelector('meta[property="og:title"]');
      if (metaTitle && metaTitle.content) {
        return metaTitle.content;
      }

      // Fallback to page title
      const titleElement = document.querySelector('h1.article-title, h1.blog-title, h1');
      if (titleElement) {
        return titleElement.textContent.trim();
      }

      return 'Blog';
    },

    // Store blog attribution
    storeBlogAttribution: function (blogInfo) {
      try {
        // Get existing attribution data
        const attributionData = sessionStorage.getItem('attribution');
        const attribution = attributionData ? JSON.parse(attributionData) : {};

        // Add blog attribution (don't overwrite existing source if it's from ads)
        // Only set blog as source if current source is direct or missing
        const currentSource = (attribution.source || 'direct').toLowerCase();

        if (currentSource === 'direct' || !attribution.source) {
          // Store blog as the source
          attribution.blog_source = 'blog';
          attribution.blog_handle = blogInfo.blogHandle;
          attribution.blog_title = this.getBlogTitle();

          if (blogInfo.articleHandle) {
            attribution.blog_article = blogInfo.articleHandle;
          }

          attribution.blog_url = blogInfo.fullUrl;
          attribution.blog_timestamp = blogInfo.timestamp;

          // Update source to blog if it was direct
          if (currentSource === 'direct') {
            attribution.source = 'blog';
            attribution.medium = 'content';
          }
        } else {
          // Keep existing source (e.g., facebook, google) but note blog visit
          attribution.blog_visited = true;
          attribution.blog_handle = blogInfo.blogHandle;
          attribution.blog_title = this.getBlogTitle();

          if (blogInfo.articleHandle) {
            attribution.blog_article = blogInfo.articleHandle;
          }

          attribution.blog_url = blogInfo.fullUrl;
          attribution.blog_timestamp = blogInfo.timestamp;
        }

        // Save back to sessionStorage
        sessionStorage.setItem('attribution', JSON.stringify(attribution));

        // Also store in localStorage for longer persistence (30 days)
        const blogHistory = localStorage.getItem('blog_history');
        let history = blogHistory ? JSON.parse(blogHistory) : [];

        history.unshift({
          blogHandle: blogInfo.blogHandle,
          articleHandle: blogInfo.articleHandle,
          title: this.getBlogTitle(),
          url: blogInfo.fullUrl,
          timestamp: blogInfo.timestamp,
        });

        // Keep only last 10 blog visits
        if (history.length > 10) {
          history = history.slice(0, 10);
        }

        localStorage.setItem('blog_history', JSON.stringify(history));

        // Send event to GA4 if available
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'blog_visit_tracked', {
            event_category: 'Blog Attribution',
            blog_handle: blogInfo.blogHandle,
            article_handle: blogInfo.articleHandle || 'blog_index',
            non_interaction: true,
          });
        }
      } catch (e) {
        // Fail silently
        console.error('Blog attribution error:', e);
      }
    },

    // Initialize tracking
    init: function () {
      if (!this.isBlogPage()) {
        return;
      }

      const blogInfo = this.getBlogInfo();
      if (!blogInfo) {
        return;
      }

      // Store blog attribution
      this.storeBlogAttribution(blogInfo);
    },
  };

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      BlogAttribution.init();
    });
  } else {
    BlogAttribution.init();
  }

  // Make available globally for debugging
  window.BlogAttribution = BlogAttribution;
})();
